import React from "react";
import "./TradeMark.css";

const TradeMark = () => {
  return (
    <div className="trademark-container">
      <div className="trademark-disclaimer">
        <h1 className="disclaimer-title">TRADEMARK DISCLAIMER</h1>
      </div>

      <div className="disclaimer-content">
        <p className="disclaimer-text">
          WireOx operates as an independent, third-party provider of replacement
          and repair parts. We have no affiliation, partnership, sponsorship, or
          endorsement relationship with any original equipment manufacturer
          (OEM) whose products are referenced on this website.
        </p>

        <p className="disclaimer-text">
          WireOx references brand names solely to help customers identify
          compatible replacement parts — nothing more. Such references do not
          constitute any claim of ownership, authorization, or commercial
          association.
        </p>

        <p className="disclaimer-text">
          Apple®, iPhone®, iPad®, iPod®, Mac®, iWatch® are trademarks of Apple
          Inc. Samsung® and Galaxy® are trademarks of Samsung Electronics Co.,
          Ltd. LG® and Motorola® are trademarks of their respective owners.
        </p>

        <p className="disclaimer-text">
          WireOx is committed to sourcing high-quality compatible components
          meeting rigorous performance standards. Customers are encouraged to
          verify compatibility before purchase.
        </p>
        <p className="disclaimer-text">
          By using this site, you acknowledge and agree to this disclaimer, our
          Privacy Policy, and our Terms & Conditions. WireOx reserves the right
          to update this disclaimer at any time.
        </p>
      </div>
    </div>
  );
};

export default TradeMark;
